import { createStore } from 'vuex';
import axiosConfig from '../lib/axiosConfig'; // Import the Axios instance
import userModule from './modules/userModule';
import articleModule from './modules/articleModule';
import hashModule from './modules/hashModule';
import appModule from './modules/appModule';
import collectionModule from './modules/collectionModule';
import channelModule from './modules/channelModule';
import materialModule from './modules/materialModule';
import segmentModule from './modules/segmentModule';
import tgConnectorModule from './modules/tgConnectorModule';
import narezkaModule from './modules/narezkaModule';
import transactionsModule from './modules/transactionsModule';
import searchModule from './modules/searchModule';
import materialFilterModule from './modules/materialFilterModule';
import shlokaModule from './modules/shlokaModule';
import historyModule from './modules/historyModule';
import videoPlayerModule from './modules/videoPlayerModule';
import meetingModule from './modules/meetingModule';
import meetingsDashboardModule from './modules/meetingsDashboardModule';
import apiModule from './modules/apiModule';
import subscriptionModule from './modules/subscriptionModule';

const store = createStore({
  modules: {
    hash: hashModule,
    user: userModule,
    article: articleModule,
    segment: segmentModule,
    app: appModule,
    collection: collectionModule,
    channel: channelModule,
    material: materialModule,
    tgconnector: tgConnectorModule,
    narezka: narezkaModule,
    transactions: transactionsModule,
    search: searchModule,
    materialFilter: materialFilterModule,
    shloka: shlokaModule,
    history: historyModule,
    videoPlayer: videoPlayerModule,
    meeting: meetingModule,
    meetingsDashboard: meetingsDashboardModule,
    api: apiModule,
    subscription: subscriptionModule
  },
  state: {
    // Global state if needed
  },
  mutations: {
    // Global mutations if needed
  },
  actions: {
    // Global actions if needed
  },
  getters: {
    // Global getters if needed
  },
});

store.$axiosInstance = axiosConfig; // Set the axiosInstance in the store

export default store;
